import React, {useState} from 'react';
import {useDispatch} from 'react-redux';
import {Link, useHistory} from 'react-router-dom';
import {toast} from 'react-toastify';
import {useFormik} from 'formik';
import {useTranslation} from 'react-i18next';
import {Button, Input} from '@components';
import {faLock} from '@fortawesome/free-solid-svg-icons';

import * as Yup from 'yup';

import * as UserService from '@app/services/UserService';
import {ResponseCode} from '@app/constants/Common';

const Login = () => {
    const [isLoading, setIsLoading] = useState(false);
    const [errorMessage, setErrorMessage] = useState("");
    const dispatch = useDispatch();

    const history = useHistory();
    const [t] = useTranslation();
    const changePassword = async (username, currentPassword, newPassword, confirmPassword) => {
        setIsLoading(true);
        setErrorMessage("");
        UserService.requestChangePassword(
            {
                username: username,
                current_password: currentPassword,
                new_password: newPassword,
                confirm_password: confirmPassword}).then((res) => {
            console.log(JSON.stringify(res))
            if (res.sts_code === ResponseCode.SUCCESS) {
                toast.success(`Đổi mật khẩu thành công.`);
                history.push('/login');
            } else {
                setErrorMessage(errorMessage)
            }
        }).catch((error) => {
            // toast.error(`Có lỗi xảy ra trong quá trình xử lý.`);
        }).finally(() => {
            setIsLoading(false);
        })
    };

    const formik = useFormik({
        initialValues: {
            username: '',
            currentPassword: '',
            newPassword: '',
            confirmPassword: '',
        },
        validationSchema: Yup.object({
            username: Yup.string()
                .required('Required'),
            currentPassword: Yup.string()
                .min(8, 'Must be 8 characters or more')
                .max(30, 'Must be 30 characters or less')
                .required('Required'),
            newPassword: Yup.string()
                .min(8, 'Must be 8 characters or more')
                .max(30, 'Must be 30 characters or less')
                .required('Required')
                .test(
                    "regex",
                    "Password must be min 8 characters, and have 1 Special Character, 1 Uppercase, 1 Number and 1 Lowercase",
                    val => {
                        let regExp = new RegExp(
                            "^(?=.*\\d)(?=.*[!@#$%^&*])(?=.*[a-z])(?=.*[A-Z]).{8,}$"
                        );
                        console.log(regExp.test(val), regExp, val);
                        return regExp.test(val);
                    }
                ),
            confirmPassword: Yup.string()
                .min(8, 'Must be 8 characters or more')
                .max(30, 'Must be 30 characters or less')
                .required('Required')
                .test(
                    "regex",
                    "Password must be min 8 characters, and have 1 Special Character, 1 Uppercase, 1 Number and 1 Lowercase",
                    val => {
                        let regExp = new RegExp(
                            "^(?=.*\\d)(?=.*[!@#$%^&*])(?=.*[a-z])(?=.*[A-Z]).{8,}$"
                        );
                        console.log(regExp.test(val), regExp, val);
                        return regExp.test(val);
                    }
                ),
        }),
        onSubmit: async (values) => {
            // login(values.currentPassword, values.newPassword);
            await changePassword(values.username, values.currentPassword, values.newPassword, values.confirmPassword);
        }
    });

    document.getElementById('root').classList = 'hold-transition login-page';

    return (
        <div className="login-box">
            <div className="card card-outline card-primary">
                <div className="card-header text-center">
                    <Link to="/" className="h1">
                        <b>GOPA </b>
                        <span>CRM</span>
                    </Link>
                </div>
                <div className="card-body">
                    <p className="login-box-msg">{"Đổi mật khẩu"}</p>
                    <p className={'text-danger'}>{errorMessage}</p>
                    <form onSubmit={formik.handleSubmit}>
                        <div className="mb-3">
                            <Input
                                icon={faLock}
                                placeholder="Username"
                                type="text"
                                formik={formik}
                                formikFieldProps={formik.getFieldProps(
                                    'username'
                                )}
                            />
                        </div>
                        <div className="mb-3">
                            <Input
                                icon={faLock}
                                placeholder="Current Password"
                                type="password"
                                formik={formik}
                                formikFieldProps={formik.getFieldProps(
                                    'currentPassword'
                                )}
                            />
                        </div>
                        <div className="mb-3">
                            <Input
                                icon={faLock}
                                placeholder="New Password"
                                type="password"
                                formik={formik}
                                formikFieldProps={formik.getFieldProps(
                                    'newPassword'
                                )}
                            />
                        </div>
                        <div className="mb-3">
                            <Input
                                icon={faLock}
                                placeholder="Confirm Password"
                                type="password"
                                formik={formik}
                                formikFieldProps={formik.getFieldProps(
                                    'confirmPassword'
                                )}
                            />
                        </div>

                        <div className="row">
                            <div className="col-8 mt-3">
                                <Button
                                    block
                                    type="submit"
                                    isLoading={isLoading}
                                >
                                    {'Đổi mật khẩu'}
                                </Button>
                            </div>
                        </div>
                    </form>
                </div>
            </div>
        </div>
    );
};

export default Login;
